import React from "react";
import PropTypes from "prop-types";
import { graphql, StaticQuery } from "gatsby";
import { FaComments, FaShareAlt, FaTimes } from "react-icons/fa/";
import moment from "moment";
import ShareButtons from "../ShareButtons";

class AuthorFooter extends React.Component {
  state = {
    showSocial: false
  };

  getAuthorFooterClasses = () => {
    return this.props.showRelatedPosts === false ? "shown" : "hidden";
  };

  toggleSocial = () => {
    this.setState({ showSocial: !this.state.showSocial });
  };

  render() {
    const { theme, authorId, postDate, postTitle, postExcerpt, postUrl, postCover } = this.props;

    const dateObj = moment(postDate);
    const formattedDate = dateObj.format("MMMM Do, YYYY");

    const iconSize = 35;

    return (
      <StaticQuery
        query={graphql`
          query AuthorFooterQuery {
            authors: allMarkdownRemark(
              limit: 1000
              sort: { fields: [fields___prefix], order: DESC }
              filter: { frontmatter: { identifier: { ne: null } } }
            ) {
              edges {
                node {
                  fields {
                    slug
                  }
                  frontmatter {
                    bio
                    identifier
                    name
                    avatar {
                      childImageSharp {
                        desktop: resize(width: 300, height: 300, quality: 90, cropFocus: CENTER) {
                          src
                        }
                        tablet: resize(width: 150, height: 150, quality: 90, cropFocus: CENTER) {
                          src
                        }
                        mobile: resize(width: 50, height: 50, quality: 90, cropFocus: CENTER) {
                          src
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const {
            authors: { edges: authorsRes }
          } = data;

          // Find matching author
          const authorObj = authorsRes.find(
            author => author.node.frontmatter.identifier === authorId
          );

          const authorName = authorObj.node.frontmatter.name;
          const authorAvatar = authorObj.node.frontmatter.avatar.childImageSharp.mobile.src;
          const authorSlug = "/about";

          return (
            <React.Fragment>
              <div className={`default ${this.getAuthorFooterClasses()}`}>
                <section className={`socialoptions ${this.state.showSocial ? "shown" : "hidden"}`}>
                  <ul className="sharebuttons">
                    <li>
                      <span className="socialdark closeshare" onClick={this.toggleSocial}>
                        <FaTimes />
                      </span>
                    </li>
                  </ul>
                  <ShareButtons
                    theme={theme}
                    iconSize={iconSize}
                    postUrl={postUrl}
                    postTitle={postTitle}
                    postExcerpt={postExcerpt}
                    postCover={postCover}
                  />
                </section>
                <section className="authorinfo">
                  <a href={authorSlug} className="authorname">
                    <img src={authorAvatar} className="gravatar" alt={authorName} /> {authorName}
                  </a>
                  <span className="authordate">Posted on {formattedDate}</span>
                </section>
                <ul className="postoptions">
                  <li className="showcomments">
                    <span className="optionIcon">
                      <FaComments />
                    </span>
                    Comments
                  </li>
                  <li className="showsocial" onClick={this.toggleSocial}>
                    <span className="optionIcon">
                      <FaShareAlt />
                    </span>
                    Share
                  </li>
                </ul>
              </div>

              {/* --- STYLES --- */}
              {/*language=SCSS*/}
              <style jsx>{`
                .default {
                  position: relative;
                  padding: 22px 25px 15px;

                  .socialoptions {
                    position: absolute;
                    bottom: 38px;
                    width: 100%;
                    background: rgba(244, 244, 244, 0.7);
                    height: 75px;
                    margin-left: -25px;

                    .socialdark {
                      display: block;
                      width: 35px;
                      height: 35px;
                      background: #f2f2f2;
                      color: #636c77;
                      border-radius: 70px;
                      font-size: 12px;
                      text-align: center;
                      line-height: 35px;
                      @include transition(background 0.15s ease-in);
                    }

                    .closeshare {
                      cursor: pointer;
                    }

                    ul {
                      float: right;
                      list-style: none;
                      margin: 23px 15px 0 0;

                      li {
                        float: left;
                        margin-right: 10px;
                      }
                    }

                    &.hidden {
                      display: none;
                    }

                    &.shown {
                      display: block;
                    }
                  }

                  .authorinfo {
                    font-family: ${theme.font.reidweb.main};
                    font-size: 15px;
                    font-weight: 400;
                    line-height: normal;
                    float: left;

                    .gravatar {
                      width: 30px;
                      height: 30px;
                      border-radius: 60px;
                      vertical-align: -9px;
                      margin-right: 10px;
                    }

                    .authorname {
                      color: #585858;
                    }

                    .authordate {
                      color: #b5b5b5;
                      font-size: 15px;

                      &:before {
                        font-family: "arial";
                        font-size: 8px;
                        content: "•";
                        vertical-align: 3px;
                        margin: 0 10px;
                      }
                    }
                  }

                  .postoptions {
                    float: right;
                    margin: 0;
                    list-style: none;
                    font-family: ${theme.font.reidweb.subheader};
                    font-size: 11px;
                    font-weight: 400;
                    line-height: normal;
                    text-transform: uppercase;

                    li {
                      display: block;
                      float: left;
                      border-left: 1px solid #dadada;
                      padding: 11px 20px;
                      color: #858585;
                      cursor: pointer;
                      @include transition(color 0.15s ease-in-out);

                      .optionIcon {
                        margin-right: 6px;
                      }

                      &:hover {
                        color: #323232;
                      }
                    }

                    i {
                      margin-right: 10px;
                    }

                    li:first-child {
                      border: 0;
                    }

                    li:last-child {
                      padding-right: 0;
                    }
                  }

                  &.hidden {
                    display: none;
                  }

                  &.shown {
                    display: block;
                  }

                  @media (max-width: 750px) {
                    display: none !important;
                  }
                }
              `}</style>
            </React.Fragment>
          );
        }}
      />
    );
  }
}

AuthorFooter.propTypes = {
  theme: PropTypes.object.isRequired,
  postTitle: PropTypes.string.isRequired,
  postExcerpt: PropTypes.string.isRequired,
  postUrl: PropTypes.string.isRequired,
  postCover: PropTypes.object,
  postDate: PropTypes.string.isRequired,
  showRelatedPosts: PropTypes.bool.isRequired,
  authorId: PropTypes.string.isRequired
};

export default AuthorFooter;
